import React, { useState } from "react";
import { X, UserMinus, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { CIKIS_SEBEP_LABELS } from "./constants";
import { DateInput } from "@/components/DateInput";

export default function BulkPasifModal({ ids, onClose, onDone }) {
  const [cikis, setCikis] = useState(() => new Date().toISOString().slice(0, 10));
  const [sebep, setSebep] = useState("fesih");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    if (!cikis) { toast.error("Çıkış tarihi gerekli"); return; }
    setBusy(true);
    try {
      const r = await api.post("/personnel/bulk-deactivate", {
        ids, ise_cikis_tarihi: cikis, cikis_sebebi: sebep,
      });
      setResult(r.data);
      toast.success(`${r.data.updated} personel pasif edildi`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "İşlem başarısız");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-2 sm:p-4" data-testid="bulk-pasif-modal">
      <div className="bg-white rounded-xl shadow-xl border border-slate-200 w-full max-w-md">
        <div className="p-5 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h3 className="font-display text-lg font-bold flex items-center gap-2">
              <UserMinus size={18} className="text-amber-700" /> Toplu Pasif Yap
            </h3>
            <p className="text-xs text-slate-500 mt-0.5">
              {ids.length} personel pasife alınacak
            </p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center">
            <X size={16} />
          </button>
        </div>

        {!result ? (
          <>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 block mb-1.5">
                  İşten Çıkış Tarihi
                </label>
                <DateInput
                  data-testid="bulk-pasif-date"
                 
                  value={cikis}
                  onChange={(e) => setCikis(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm font-mono-tab focus:outline-none focus:ring-2 focus:ring-slate-900"
                />
              </div>
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 block mb-1.5">
                  Çıkış Sebebi
                </label>
                <select
                  data-testid="bulk-pasif-sebep"
                  value={sebep}
                  onChange={(e) => setSebep(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-900"
                >
                  {Object.entries(CIKIS_SEBEP_LABELS).map(([k, v]) => (
                    <option key={k} value={k}>{v}</option>
                  ))}
                </select>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-2.5 text-xs text-amber-900 flex items-start gap-2">
                <AlertCircle size={14} className="shrink-0 mt-0.5" />
                <span>
                  Seçili personellerin tümü <strong>aynı tarih</strong> ve <strong>aynı sebep</strong> ile pasife alınacak.
                  Zaten pasif olanlar atlanacak ve raporda görünecek.
                </span>
              </div>
            </div>
            <div className="p-4 border-t border-slate-200 flex justify-end gap-2">
              <button onClick={onClose} className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-semibold hover:bg-slate-50">İptal</button>
              <button
                data-testid="bulk-pasif-submit"
                onClick={submit}
                disabled={busy}
                className="px-4 py-2 rounded-lg bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-1.5"
              >
                <UserMinus size={14} /> {busy ? "İşleniyor..." : `${ids.length} Personeli Pasif Yap`}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="p-5 space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-center">
                  <div className="text-[10px] font-semibold uppercase tracking-wider text-emerald-700">Pasife Alındı</div>
                  <div className="text-3xl font-mono-tab font-bold text-emerald-900 mt-1">{result.updated}</div>
                </div>
                <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 text-center">
                  <div className="text-[10px] font-semibold uppercase tracking-wider text-amber-700">Atlanan</div>
                  <div className="text-3xl font-mono-tab font-bold text-amber-900 mt-1">{(result.skipped || []).length}</div>
                </div>
              </div>
              {(result.skipped || []).length > 0 && (
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Atlanan Kayıtlar</div>
                  <div className="max-h-32 overflow-y-auto border border-amber-200 rounded-lg bg-amber-50/60">
                    {result.skipped.map((r, i) => (
                      <div key={i} className="px-3 py-1.5 text-xs flex items-center justify-between border-b border-amber-100 last:border-b-0">
                        <span className="font-mono-tab text-amber-900 font-semibold">{r.sicil_no || "—"}</span>
                        <span className="text-amber-800">{r.ad_soyad || "—"}</span>
                        <span className="text-amber-700 text-[10px] italic">{r.reason}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="p-4 border-t border-slate-200 flex justify-end">
              <button
                onClick={onDone}
                className="px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold"
              >Tamam</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
